window._ = require('lodash');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Vue = require('vue').default;

import Lang from 'lang.js';
const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;
import messages from './ll_messages.js';
Vue.prototype.trans = new Lang({ messages, locale: default_locale, fallback: fallback_locale });

Vue.component('rezervace-sluzby', require('./components/rezervace/Sluzby.vue').default);
Vue.component('rezervace-kontakty', require('./components/rezervace/Kontakty.vue').default);
Vue.component('rezervace-storno', require('./components/rezervace/Storno.vue').default);
Vue.component('rezervace-checkin', require('./components/rezervace/Checkin.vue').default);

Vue.component('admin-objednavky', require('./components/admin/Objednavky.vue').default);
Vue.component('admin-udalosti', require('./components/admin/Udalosti.vue').default);
Vue.component('infinite-loading', require('vue-infinite-loading').default);
Vue.component('dropdown-menu', require('./components/admin/DropdownMenu.vue').default);

const app = new Vue({
    el: '#app',
});

require('./pikaday');
require('./glightbox');
